import { Nullable } from '@bybeam/platform-types';
import { useRef } from 'react';
import { v4 as uuidV4 } from 'uuid';

export default function useHelperTextId(): Nullable<string> {
  const helperTextId = useRef(`helper-text-${uuidV4()}`);
  return helperTextId.current;
}
